import Header  from "../Header";

export const USDAHeader = () => {
  return (
    <Header extended firstName="first" lastName="last">
    </Header>
  );
};
